import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import { getFactors, insertFactors } from './services/factor';
import ClipLoader from "react-spinners/ClipLoader";
import NoAccesComponent from '../../Shared/NoAccesComponent';
import { ToastContainer, toast } from 'react-toastify';


export default class FactorComponent extends React.Component {

    BreadcrumbPages = [
        { name: 'Administración', href: '', current: false },
        { name: 'Multas', href: '', current: false },
        { name: 'Factor', href: '', current: true },
    ]


    constructor(props){
        super(props);
        this.state={
            loding:true,
            dolar:0,
            euro:0,
            data:null,
            canSee: false,
            canCreate: false,
            canEdit: false
        }
    }

    componentDidMount = () => { 
        let permissions = window.localStorage.getItem('permissons');
        const userType = window.localStorage.getItem('userType');
        if(userType === 'ANALISTA') { 
        permissions = JSON.parse(permissions);
        let canCreate = false;
        let canEdit = false;
        let canSee = false;
        permissions[0].factor.forEach(element => {
            if(element.name === 'see' && element.value === true){
                canSee = true;
            }
            if(element.name === 'create' && element.value === true){
                canCreate = true;
            }
            if(element.name === 'update' && element.value === true){
                canEdit = true;
            }
        });
        this.setState({canCreate:canCreate, canEdit:canEdit, canSee:canSee, loading:false});
        }else{
        this.setState({canCreate:true, canEdit:true, canSee:true, loading:false});
        }
        this.loadFactors()
    }

    loadFactors(){
        this.setState({loading:true})
        getFactors({})
            .then((result) => {
                this.setState({data:result.data.data})
                this.setState({loading:false})
            })
            .catch((error) => console.log(error))
    }

    checkSpecialCharacters(n){
        if(n === "" || Number(n) === 0) return false;
        return true;
    }

    saveFactors(){
        this.setState({loading:true});
        insertFactors({
            id:0,
            dolarLocal: parseFloat(this.state.dolar),
            eurLocal: parseFloat(this.state.euro)
            })
            .then((result) => {
                if(result.status === 200) {
                    this.loadFactors();
                    toast(result.data.message);
                }
                this.setState({loading:false})
            })
            .catch((error) => {
                toast(error);
                this.setState({loading:false});
                console.log(error)
            })
    }

    renderFactors = () => {
        return(
             <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white rounded-lg shadow-sm ring-1 ring-gray-200 px-6 py-8 text-center">
                    <dt className="text-sm font-medium text-gray-600 mb-2">Euro Local</dt>
                    <dd className="text-3xl font-bold text-blue-950">Bs. {this.state.data?.eurLocal?.toFixed(2) || '0.00'}</dd>
                    <p className="text-xs text-gray-500 mt-1">Tasa local</p>
                </div>
                <div className="bg-white rounded-lg shadow-sm ring-1 ring-gray-200 px-6 py-8 text-center">
                    <dt className="text-sm font-medium text-gray-600 mb-2">Euro BCV</dt>
                    <dd className="text-3xl font-bold text-green-700">Bs. {this.state.data?.eurBCV?.toFixed(2) || '0.00'}</dd>
                    <p className="text-xs text-gray-500 mt-1">Banco Central</p>
                </div>
                <div className="bg-white rounded-lg shadow-sm ring-1 ring-gray-200 px-6 py-8 text-center">
                    <dt className="text-sm font-medium text-gray-600 mb-2">Dólar Local</dt>
                    <dd className="text-3xl font-bold text-blue-950">Bs. {this.state.data?.dolarLocal?.toFixed(2) || '0.00'}</dd>
                    <p className="text-xs text-gray-500 mt-1">Tasa local</p>
                </div>
                <div className="bg-white rounded-lg shadow-sm ring-1 ring-gray-200 px-6 py-8 text-center">
                    <dt className="text-sm font-medium text-gray-600 mb-2">Dólar BCV</dt>
                    <dd className="text-3xl font-bold text-green-700">Bs. {this.state.data?.dolarBCV?.toFixed(2) || '0.00'}</dd>
                    <p className="text-xs text-gray-500 mt-1">Banco Central</p>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="max-w-7xl mx-auto px-4">
                <Breadcrumb pages={this.BreadcrumbPages}/>
                {
                    this.state.loading ? 
                            <center className="py-12">
                                <ClipLoader
                                    color={'gray'}
                                    loading={true}
                                    size={50}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </center>
                        :
                       this.state.canSee ? 
                         <div className="py-6">
                            <div className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">Factores de Conversión</h2>
                                <p className="text-gray-600">Gestiona los factores de cambio para los cálculos de pagos y conversiones de moneda.</p>
                            </div>
                            
                            {this.renderFactors()}
                            
                            <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 p-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Actualizar Factores Locales</h3>
                                <p className="text-sm text-gray-600 mb-6">
                                    En esta sección podrás actualizar los factores locales para los pagos. Los valores del BCV se actualizan automáticamente.
                                </p>
                                
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                                    <div>
                                        <label htmlFor="dolar" className="block text-sm font-medium text-gray-700 mb-2">
                                            Dólar Local
                                        </label>
                                        <input
                                            id="dolar"
                                            onChange={(e) => this.setState({dolar:e.target.value})}
                                            value={this.state.dolar}
                                            type="text"
                                            step="0.01"
                                            placeholder="Ej: 36.50"
                                            className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="euro" className="block text-sm font-medium text-gray-700 mb-2">
                                            Euro Local
                                        </label>
                                        <input
                                            id="euro"
                                            onChange={(e) => this.setState({euro:e.target.value})}
                                            value={this.state.euro}
                                            type="text"
                                            step="0.01"
                                            placeholder="Ej: 38.20"
                                            className="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                        />
                                    </div>
                                    <div>
                                        <button
                                            onClick={()=>this.saveFactors()}
                                            type="button"
                                            className="w-full rounded-md bg-blue-950 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950"
                                        >
                                            Guardar Cambios
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <NoAccesComponent/>
                }
                <ToastContainer position="top-center" hideProgressBar={true}/>
            </div>
        )
    }
}